<script lang="ts">
    import {page} from "$app/stores";
    import type {Employee} from "$lib/types/employee";
    import CardLayout from "$items/CardLayout.svelte";
    import {Alert, Button, Modal, Toggle} from "flowbite-svelte";
    import {DownloadSolid, TrashBinSolid, UploadSolid} from "flowbite-svelte-icons";
    import {deleteEmployeeImage} from "$lib/calls/employee";
    import EmployeeUploadModal from "$lib/partials/employee/EmployeeUploadModal.svelte";

    export let employee: Employee = $page.data.employee;

    let selectedImage = null;
    let imageModal = false;
    let photoUploadModal = false;

    const setImage = (image) => {
        selectedImage = image
        imageModal = true;
    }
    const deleteImage = () => {
        imageModal = false;
        deleteEmployeeImage(employee.uuid, selectedImage).then((e) => {
            employee.images = employee.images.filter(x => x.id !== selectedImage.id);
        })
    }


</script>

<CardLayout title="Fotos" className="sticky top-24">
    <div slot="card-header" class="relative">
        <div class="absolute right-0 w-36 grid place-items-end">
            <Button on:click={() => photoUploadModal = true} size="xs" class="mt-1">
                <UploadSolid class="w-3 h-3 mr-2"/>Foto hochladen
            </Button>
        </div>

    </div>
    <div class="grid place-items-center gap-2">
        {#if employee.avatarFile}
            <div role="button" tabindex="0" on:click={() => setImage({
                location: employee.avatarFile,
                blockInteraction: true,
                imageTag: 'Avatar'
            })} on:keydown={() => setImage({
                location: employee.avatarFile,
                blockInteraction: true
            })} class="relative w-1/2 rounded border cursor-pointer hover:border-primary-400">
                <img class="w-full" src={employee.avatarFile} alt="Profile-Picture">
            </div>
        {/if}
        {#each employee.images.filter(x => !x.location.toLowerCase().includes('.pdf')) as image}
            <div role="button" tabindex="0" on:click={() => setImage(image)} on:keydown={() => setImage(image)} class="relative w-1/2 rounded border cursor-pointer hover:border-primary-400">
                <img class="w-full" src={image.location} alt={image.location}>
            </div>
        {/each}
    </div>

</CardLayout>

<EmployeeUploadModal bind:open={photoUploadModal} bind:employee/>
<Modal title={selectedImage?.imageTag?.toUpperCase()} bind:open={imageModal}>
    <img class="w-full" src={selectedImage.location} alt={selectedImage.location}>
    {#if selectedImage.documentNumber}
        <p>Number: {selectedImage.documentNumber}</p>
    {/if}
    {#if selectedImage.blockInteraction}
        <Alert color="yellow">
            <p>Profilbilder müssen über "Bearbeiten" -> Avatar geändert werden.</p>
        </Alert>
    {:else}
        <div class="flex justify-between">

            <Button href={selectedImage.location}>
                <DownloadSolid class="w-3 h-3 mr-2"/>
                <span>Download</span>
            </Button>
            <Button on:click={() => deleteImage()} color="red">
                <TrashBinSolid class="w-3 h-3 mr-2"/>
                <span>Löschen</span>
            </Button>
        </div>
    {/if}

</Modal>